import { render, staticRenderFns } from "./ViewProcessDefinitionStep.vue?vue&type=template&id=5650cd6a&scoped=true&"
import script from "./ViewProcessDefinitionStep.vue?vue&type=script&lang=js&"
export * from "./ViewProcessDefinitionStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5650cd6a",
  null
  
)

export default component.exports